import React from 'react'
import { useFormContext } from 'react-hook-form'

import { RadioButton } from '../baseInputs'

const PrivateOrCompanyCar = ({ optional, ...rest }) => {
  const { formState, getFieldState } = useFormContext()
  const { error } = getFieldState('pvt_company_car', formState)

  return (
    <div>
      <p className="font-medium mt-5 mb-1">
        Who is this vehicle for?{' '}
        {optional && (
          <span className="text-xs lowercase whitespace-nowrap">
            (optional)
          </span>
        )}
      </p>
      <div className="radio-btn-container flex gap-2 flex-col mb-5">
        <RadioButton
          name="pvt_company_car"
          label="Myself"
          value="Private"
          errorDisabled
          {...rest}
        />
        <RadioButton
          name="pvt_company_car"
          label="Myself (Company Vehicle)"
          value="Company"
          errorDisabled
          {...rest}
        />
        <RadioButton
          name="pvt_company_car"
          label="Fleet & Business"
          value="Fleet"
          errorDisabled
          {...rest}
        />
        {error && (
          <p className="text-red text-tiny mt-1" role="alert">
            {error.message}
          </p>
        )}
      </div>
    </div>
  )
}

export default PrivateOrCompanyCar
